module.exports = __webpack_public_path__ + "static/img/ic_text.6f0afc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/ic_text.png
// module id = 9vFS
// module chunks = 1